




































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({
  name: 'VerticalList'
})
export default class VerticalList extends Vue {
  @Prop({ default: null })
  private component: any


  private list: any = this.component.action.config

  private get getStyle (): string {
    const ret: Array<string> = []
    this.component.style.forEach((item: any) => {
      const unit: string = item.unit || ''
      if (item.val) {
        if (item.attr === 'background-image') {
          ret.push(item.attr + ':url(' + item.val + ')')
        } else {
          ret.push(item.attr + ':' + item.val + unit)
        }
      }
    })
    return ret.join(';')
  }

  private getItemStyle (key: string): string {
    const ret: Array<string> = []
    this.component.others.config.forEach((item: any) => {
      const isItem: number = item.attr.indexOf(key)
      const idx: number = item.attr.indexOf('_')
      if (isItem === 0) {
        const unit: string = item.unit || ''
        item.val && ret.push(item.attr.substring(idx + 1, item.attr.length) + ':' + item.val + unit)
      }
    })
    return ret.join(';')
  }
}
